import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCollectorDirectoriesInfoQueryVariables = Types.Exact<{
  folderId: Types.Scalars['Long']['input'];
  refresh: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetCollectorDirectoriesInfoQuery = { collectorDirectoriesInfo: { parentFolder: { id: number, fullPath: string | null, fileBrowseType: string, humanReadablePath: string | null, parentFolderIds: Array<number | null> | null, isEditable: boolean, project: { id: number, name: string } | null } | null, children: Array<{ deletable: boolean, isEditable: boolean, isProtected: boolean | null, canChangeProtectedStatus: boolean, id: number, fullPath: string | null, fileBrowseType: string, humanReadablePath: string | null, parentFolderIds: Array<number | null> | null, fileName: string | null, description: string | null, lastModified: string | null, typeDisplayName: string | null, size: number, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, url: string | null, previewable: boolean, creator: { id: number, display: string | null, firstName: string | null, lastName: string | null, username: string | null } | null, organisms: Array<{ id: number, name: string | null, hidden: boolean, species: { name: string } | null } | null> | null, parents: Array<{ id: number | null, name: string | null, parentType: { name: string } }> | null, samples: Array<{ id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null } | null> | null } | null> | null } | null };

export type GetFileParentIdsQueryVariables = Types.Exact<{
  fileId: Types.Scalars['Long']['input'];
}>;


export type GetFileParentIdsQuery = { collectorDirectoriesInfo: { parentFolder: { id: number, fullPath: string | null, fileBrowseType: string, humanReadablePath: string | null, parentFolderIds: Array<number | null> | null, isEditable: boolean, project: { id: number, name: string } | null } | null } | null };

export type GetFileInfoCardQueryVariables = Types.Exact<{
  fileId: Types.Scalars['Long']['input'];
}>;


export type GetFileInfoCardQuery = { projectFileById: { id: number, fileName: string | null, fileType: string | null, fileBrowseType: string, parentFolderIds: Array<number | null> | null, isEditable: boolean, humanReadablePath: string | null, description: string | null, previewable: boolean, created: string | null, lastModified: string | null, size: number, url: string | null, indexingStatus: Types.IndexStatus | null, creator: { display: string | null } | null, lastModifier: { display: string | null } | null, project: { id: number, name: string, color: string | null } | null, contentType: { name: string | null, description: string | null } | null } | null };

export type GetFilesInProjectQueryVariables = Types.Exact<{
  folderId: Types.Scalars['Long']['input'];
}>;


export type GetFilesInProjectQuery = { collectorDirectoriesInfo: { children: Array<{ fileName: string | null, id: number } | null> | null } | null };

export type GetFileEditingQueryVariables = Types.Exact<{
  fileId: Types.Scalars['Long']['input'];
}>;


export type GetFileEditingQuery = { projectFileById: { id: number, fileName: string | null, fileBrowseType: string, description: string | null, lastModified: string | null, url: string | null, isProtected: boolean | null, parentFolderIds: Array<number | null> | null, organisms: Array<{ id: number, name: string | null } | null> | null } | null };

export type GetFileEventsQueryVariables = Types.Exact<{
  fileId: Types.Scalars['Long']['input'];
}>;


export type GetFileEventsQuery = { projectFileById: { eventResources: Array<{ playbookEvent: { id: number, alias: string | null, note: string | null, status: string, created: string, shortSummary: string | null, playbook: { id: number, name: string, nameSuffix: string | null, protectedPlaybook: boolean | null, standard: boolean | null, type: { id: number | null, name: string | null, class: string | null }, config: { icon: string | null } | null }, owner: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null }, project: { id: number, name: string, description: string | null, color: string | null } | null, job: { tool: string | null } | null, results: Array<{ resourceType: string | null, file: { fileName: string | null } | null } | null> | null } | null }> | null } | null };

export type GetFileResourcesQueryVariables = Types.Exact<{
  fileId: Types.Scalars['Long']['input'];
}>;


export type GetFileResourcesQuery = { projectFileById: { organisms: Array<{ id: number, name: string | null, type: string | null, description: string | null, hidden: boolean, species: { name: string } | null } | null> | null, parents: Array<{ id: number | null, name: string | null, description: string | null, sampleCount: number, parentType: { name: string } }> | null, samples: Array<{ id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, locked: boolean | null, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null } | null> | null } | null };

export type GetFilesTileInfoQueryVariables = Types.Exact<{
  fileIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
}>;


export type GetFilesTileInfoQuery = { projectFilesById: Array<{ id: number, fileName: string | null, url: string | null, humanReadablePath: string | null, fullPath: string | null, description: string | null, created: string | null, lastModified: string | null, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, previewable: boolean, typeDisplayName: string | null, project: { id: number, name: string, color: string | null } | null, contentType: { name: string | null, suffix: string | null, description: string | null, id: number | null } | null } | null> };

export type ValidateFileNamesQueryVariables = Types.Exact<{
  folderId: Types.Scalars['Long']['input'];
  fileNames: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type ValidateFileNamesQuery = { fileNameExistsInCollector: Array<string | null> | null };

export type PreviewDialogBasicsQueryVariables = Types.Exact<{
  fileId: Types.Scalars['Long']['input'];
}>;


export type PreviewDialogBasicsQuery = { projectFileById: { id: number, fileName: string | null, lastModified: string | null, fileBrowseType: string } | null };

export type FileDownloadQueryVariables = Types.Exact<{
  fileId: Types.Scalars['Long']['input'];
}>;


export type FileDownloadQuery = { projectFileById: { id: number, fileName: string | null, fileBrowseType: string } | null };

export type GetFileSuggestionsContextQueryVariables = Types.Exact<{
  fileIds: Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input'];
}>;


export type GetFileSuggestionsContextQuery = { projectFilesById: Array<{ organisms: Array<{ id: number, name: string | null } | null> | null, parents: Array<{ id: number | null, name: string | null, parentType: { name: string } }> | null, samples: Array<{ id: number, name: string | null, type: { id: number, name: string } | null } | null> | null, playbookEvents: Array<{ id: number, alias: string | null, created: string, playbook: { id: number, name: string } }> | null } | null> };

export type SearchProjectFilesQueryVariables = Types.Exact<{
  searchTerm: Types.InputMaybe<Types.Scalars['String']['input']>;
  fileExtensions: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  projectId: Types.InputMaybe<Types.Scalars['Long']['input']>;
  genomeIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
  eventIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
  parentIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
  sampleIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
  sortOrder: Types.InputMaybe<Types.Scalars['String']['input']>;
  folderId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type SearchProjectFilesQuery = { search: { projectFilesContextSearch: { totalCount: number | null, projectFiles: Array<{ path: string | null, id: number, fullPath: string | null, fileBrowseType: string, humanReadablePath: string | null, parentFolderIds: Array<number | null> | null, fileName: string | null, description: string | null, lastModified: string | null, typeDisplayName: string | null, size: number, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, url: string | null, previewable: boolean, project: { id: number, name: string, description: string | null, color: string | null } | null, creator: { id: number, display: string | null, firstName: string | null, lastName: string | null, username: string | null } | null, organisms: Array<{ id: number, name: string | null, hidden: boolean, species: { name: string } | null } | null> | null, parents: Array<{ id: number | null, name: string | null, parentType: { name: string } }> | null, samples: Array<{ id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null } | null> | null }> } } };

export type BrowsingDirectoryFragment = { id: number, fullPath: string | null, fileBrowseType: string, humanReadablePath: string | null, parentFolderIds: Array<number | null> | null, isEditable: boolean, project: { id: number, name: string } | null };

export type OrganismTileFragment = { id: number, name: string | null, type: string | null, description: string | null, hidden: boolean, species: { name: string } | null };

export type PlaybookEventStackTileBasicsFragment = { id: number, alias: string | null, note: string | null, status: string, created: string, shortSummary: string | null, playbook: { id: number, name: string, nameSuffix: string | null, protectedPlaybook: boolean | null, standard: boolean | null, type: { id: number | null, name: string | null, class: string | null }, config: { icon: string | null } | null }, owner: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null }, project: { id: number, name: string, description: string | null, color: string | null } | null, job: { tool: string | null } | null, results: Array<{ resourceType: string | null, file: { fileName: string | null } | null } | null> | null };

export type ProjectFileGridFragment = { id: number, fullPath: string | null, fileBrowseType: string, humanReadablePath: string | null, parentFolderIds: Array<number | null> | null, fileName: string | null, description: string | null, lastModified: string | null, typeDisplayName: string | null, size: number, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, url: string | null, previewable: boolean, creator: { id: number, display: string | null, firstName: string | null, lastName: string | null, username: string | null } | null, organisms: Array<{ id: number, name: string | null, hidden: boolean, species: { name: string } | null } | null> | null, parents: Array<{ id: number | null, name: string | null, parentType: { name: string } }> | null, samples: Array<{ id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null } | null> | null };

export type BrowsingProjectFileFragment = { deletable: boolean, isEditable: boolean, isProtected: boolean | null, canChangeProtectedStatus: boolean, id: number, fullPath: string | null, fileBrowseType: string, humanReadablePath: string | null, parentFolderIds: Array<number | null> | null, fileName: string | null, description: string | null, lastModified: string | null, typeDisplayName: string | null, size: number, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, url: string | null, previewable: boolean, creator: { id: number, display: string | null, firstName: string | null, lastName: string | null, username: string | null } | null, organisms: Array<{ id: number, name: string | null, hidden: boolean, species: { name: string } | null } | null> | null, parents: Array<{ id: number | null, name: string | null, parentType: { name: string } }> | null, samples: Array<{ id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null } | null> | null };

export type SampleTileFragment = { id: number, name: string | null, description: string | null, created: string | null, modified: string | null, deleted: boolean | null, hidden: boolean, locked: boolean | null, status: { name: string, color: string | null } | null, type: { name: string } | null, project: { id: number, name: string, color: string | null } | null };

export type ProjectFileTileFragment = { id: number, fileName: string | null, url: string | null, humanReadablePath: string | null, fullPath: string | null, description: string | null, created: string | null, lastModified: string | null, deleted: boolean, hidden: boolean, indexingStatus: Types.IndexStatus | null, previewable: boolean, typeDisplayName: string | null, project: { id: number, name: string, color: string | null } | null, contentType: { name: string | null, suffix: string | null, description: string | null, id: number | null } | null };

export const BrowsingDirectoryFragmentDoc = gql`
    fragment BrowsingDirectory on ProjectFile {
  id
  fullPath
  fileBrowseType
  humanReadablePath
  parentFolderIds
  isEditable
  project {
    id
    name
  }
}
    `;
export const OrganismTileFragmentDoc = gql`
    fragment OrganismTile on Organism {
  id
  name
  type
  description
  hidden
  species {
    name
  }
}
    `;
export const PlaybookEventStackTileBasicsFragmentDoc = gql`
    fragment PlaybookEventStackTileBasics on PlaybookEvent {
  id
  alias
  note
  status
  created
  playbook {
    id
    name
    nameSuffix
    protectedPlaybook
    standard
    type {
      id
      name
      class
    }
    config {
      icon
    }
  }
  owner {
    id
    username
    firstName
    lastName
    email
    display
  }
  project {
    id
    name
    description
    color
  }
  job {
    tool
  }
  shortSummary
  results {
    resourceType
    file {
      fileName
    }
  }
}
    `;
export const ProjectFileGridFragmentDoc = gql`
    fragment ProjectFileGrid on ProjectFile {
  id
  fullPath
  fileBrowseType
  humanReadablePath
  parentFolderIds
  fileName
  description
  lastModified
  typeDisplayName
  size
  deleted
  hidden
  indexingStatus
  url
  previewable
  creator {
    id
    display
    firstName
    lastName
    username
  }
  organisms {
    id
    name
    hidden
    species {
      name
    }
  }
  parents {
    id
    name
    parentType {
      name
    }
  }
  samples {
    id
    name
    description
    status {
      name
      color
    }
    type {
      name
    }
    created
    modified
    project {
      id
      name
      color
    }
    deleted
    hidden
  }
}
    `;
export const BrowsingProjectFileFragmentDoc = gql`
    fragment BrowsingProjectFile on ProjectFile {
  ...ProjectFileGrid
  deletable
  isEditable
  isProtected
  canChangeProtectedStatus
}
    ${ProjectFileGridFragmentDoc}`;
export const SampleTileFragmentDoc = gql`
    fragment SampleTile on Sample {
  id
  name
  description
  status {
    name
    color
  }
  type {
    name
  }
  created
  modified
  project {
    id
    name
    color
  }
  deleted
  hidden
  locked
}
    `;
export const ProjectFileTileFragmentDoc = gql`
    fragment ProjectFileTile on ProjectFile {
  id
  fileName
  url
  humanReadablePath
  fullPath
  description
  created
  lastModified
  deleted
  hidden
  indexingStatus
  previewable
  project {
    id
    name
    color
  }
  typeDisplayName
  contentType {
    name
    suffix
    description
    id
  }
}
    `;
export const GetCollectorDirectoriesInfoDocument = gql`
    query getCollectorDirectoriesInfo($folderId: Long!, $refresh: Boolean) {
  collectorDirectoriesInfo(folderId: $folderId, refresh: $refresh) {
    parentFolder {
      ...BrowsingDirectory
    }
    children {
      ...BrowsingProjectFile
    }
  }
}
    ${BrowsingDirectoryFragmentDoc}
${BrowsingProjectFileFragmentDoc}`;

/**
 * __useGetCollectorDirectoriesInfoQuery__
 *
 * To run a query within a React component, call `useGetCollectorDirectoriesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectorDirectoriesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectorDirectoriesInfoQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useGetCollectorDirectoriesInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCollectorDirectoriesInfoQuery, GetCollectorDirectoriesInfoQueryVariables> & ({ variables: GetCollectorDirectoriesInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectorDirectoriesInfoQuery, GetCollectorDirectoriesInfoQueryVariables>(GetCollectorDirectoriesInfoDocument, options);
      }
export function useGetCollectorDirectoriesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectorDirectoriesInfoQuery, GetCollectorDirectoriesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectorDirectoriesInfoQuery, GetCollectorDirectoriesInfoQueryVariables>(GetCollectorDirectoriesInfoDocument, options);
        }
export function useGetCollectorDirectoriesInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectorDirectoriesInfoQuery, GetCollectorDirectoriesInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollectorDirectoriesInfoQuery, GetCollectorDirectoriesInfoQueryVariables>(GetCollectorDirectoriesInfoDocument, options);
        }
export type GetCollectorDirectoriesInfoQueryHookResult = ReturnType<typeof useGetCollectorDirectoriesInfoQuery>;
export type GetCollectorDirectoriesInfoLazyQueryHookResult = ReturnType<typeof useGetCollectorDirectoriesInfoLazyQuery>;
export type GetCollectorDirectoriesInfoSuspenseQueryHookResult = ReturnType<typeof useGetCollectorDirectoriesInfoSuspenseQuery>;
export type GetCollectorDirectoriesInfoQueryResult = Apollo.QueryResult<GetCollectorDirectoriesInfoQuery, GetCollectorDirectoriesInfoQueryVariables>;
export const GetFileParentIdsDocument = gql`
    query getFileParentIds($fileId: Long!) {
  collectorDirectoriesInfo(folderId: $fileId, refresh: false) {
    parentFolder {
      ...BrowsingDirectory
    }
  }
}
    ${BrowsingDirectoryFragmentDoc}`;

/**
 * __useGetFileParentIdsQuery__
 *
 * To run a query within a React component, call `useGetFileParentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileParentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileParentIdsQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileParentIdsQuery(baseOptions: Apollo.QueryHookOptions<GetFileParentIdsQuery, GetFileParentIdsQueryVariables> & ({ variables: GetFileParentIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileParentIdsQuery, GetFileParentIdsQueryVariables>(GetFileParentIdsDocument, options);
      }
export function useGetFileParentIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileParentIdsQuery, GetFileParentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileParentIdsQuery, GetFileParentIdsQueryVariables>(GetFileParentIdsDocument, options);
        }
export function useGetFileParentIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileParentIdsQuery, GetFileParentIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileParentIdsQuery, GetFileParentIdsQueryVariables>(GetFileParentIdsDocument, options);
        }
export type GetFileParentIdsQueryHookResult = ReturnType<typeof useGetFileParentIdsQuery>;
export type GetFileParentIdsLazyQueryHookResult = ReturnType<typeof useGetFileParentIdsLazyQuery>;
export type GetFileParentIdsSuspenseQueryHookResult = ReturnType<typeof useGetFileParentIdsSuspenseQuery>;
export type GetFileParentIdsQueryResult = Apollo.QueryResult<GetFileParentIdsQuery, GetFileParentIdsQueryVariables>;
export const GetFileInfoCardDocument = gql`
    query getFileInfoCard($fileId: Long!) {
  projectFileById(fileId: $fileId) {
    id
    fileName
    fileType
    fileBrowseType
    parentFolderIds
    isEditable
    humanReadablePath
    description
    previewable
    creator {
      display
    }
    created
    lastModified
    lastModifier {
      display
    }
    size
    url
    project {
      id
      name
      color
    }
    contentType {
      name
      description
    }
    indexingStatus
  }
}
    `;

/**
 * __useGetFileInfoCardQuery__
 *
 * To run a query within a React component, call `useGetFileInfoCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileInfoCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileInfoCardQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileInfoCardQuery(baseOptions: Apollo.QueryHookOptions<GetFileInfoCardQuery, GetFileInfoCardQueryVariables> & ({ variables: GetFileInfoCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileInfoCardQuery, GetFileInfoCardQueryVariables>(GetFileInfoCardDocument, options);
      }
export function useGetFileInfoCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileInfoCardQuery, GetFileInfoCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileInfoCardQuery, GetFileInfoCardQueryVariables>(GetFileInfoCardDocument, options);
        }
export function useGetFileInfoCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileInfoCardQuery, GetFileInfoCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileInfoCardQuery, GetFileInfoCardQueryVariables>(GetFileInfoCardDocument, options);
        }
export type GetFileInfoCardQueryHookResult = ReturnType<typeof useGetFileInfoCardQuery>;
export type GetFileInfoCardLazyQueryHookResult = ReturnType<typeof useGetFileInfoCardLazyQuery>;
export type GetFileInfoCardSuspenseQueryHookResult = ReturnType<typeof useGetFileInfoCardSuspenseQuery>;
export type GetFileInfoCardQueryResult = Apollo.QueryResult<GetFileInfoCardQuery, GetFileInfoCardQueryVariables>;
export const GetFilesInProjectDocument = gql`
    query GetFilesInProject($folderId: Long!) {
  collectorDirectoriesInfo(folderId: $folderId) {
    children {
      fileName
      id
    }
  }
}
    `;

/**
 * __useGetFilesInProjectQuery__
 *
 * To run a query within a React component, call `useGetFilesInProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesInProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesInProjectQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useGetFilesInProjectQuery(baseOptions: Apollo.QueryHookOptions<GetFilesInProjectQuery, GetFilesInProjectQueryVariables> & ({ variables: GetFilesInProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesInProjectQuery, GetFilesInProjectQueryVariables>(GetFilesInProjectDocument, options);
      }
export function useGetFilesInProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesInProjectQuery, GetFilesInProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesInProjectQuery, GetFilesInProjectQueryVariables>(GetFilesInProjectDocument, options);
        }
export function useGetFilesInProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilesInProjectQuery, GetFilesInProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilesInProjectQuery, GetFilesInProjectQueryVariables>(GetFilesInProjectDocument, options);
        }
export type GetFilesInProjectQueryHookResult = ReturnType<typeof useGetFilesInProjectQuery>;
export type GetFilesInProjectLazyQueryHookResult = ReturnType<typeof useGetFilesInProjectLazyQuery>;
export type GetFilesInProjectSuspenseQueryHookResult = ReturnType<typeof useGetFilesInProjectSuspenseQuery>;
export type GetFilesInProjectQueryResult = Apollo.QueryResult<GetFilesInProjectQuery, GetFilesInProjectQueryVariables>;
export const GetFileEditingDocument = gql`
    query getFileEditing($fileId: Long!) {
  projectFileById(fileId: $fileId) {
    id
    fileName
    fileBrowseType
    description
    lastModified
    url
    organisms {
      id
      name
    }
    isProtected
    parentFolderIds
  }
}
    `;

/**
 * __useGetFileEditingQuery__
 *
 * To run a query within a React component, call `useGetFileEditingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileEditingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileEditingQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileEditingQuery(baseOptions: Apollo.QueryHookOptions<GetFileEditingQuery, GetFileEditingQueryVariables> & ({ variables: GetFileEditingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileEditingQuery, GetFileEditingQueryVariables>(GetFileEditingDocument, options);
      }
export function useGetFileEditingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileEditingQuery, GetFileEditingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileEditingQuery, GetFileEditingQueryVariables>(GetFileEditingDocument, options);
        }
export function useGetFileEditingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileEditingQuery, GetFileEditingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileEditingQuery, GetFileEditingQueryVariables>(GetFileEditingDocument, options);
        }
export type GetFileEditingQueryHookResult = ReturnType<typeof useGetFileEditingQuery>;
export type GetFileEditingLazyQueryHookResult = ReturnType<typeof useGetFileEditingLazyQuery>;
export type GetFileEditingSuspenseQueryHookResult = ReturnType<typeof useGetFileEditingSuspenseQuery>;
export type GetFileEditingQueryResult = Apollo.QueryResult<GetFileEditingQuery, GetFileEditingQueryVariables>;
export const GetFileEventsDocument = gql`
    query getFileEvents($fileId: Long!) {
  projectFileById(fileId: $fileId) {
    eventResources {
      playbookEvent {
        ...PlaybookEventStackTileBasics
      }
    }
  }
}
    ${PlaybookEventStackTileBasicsFragmentDoc}`;

/**
 * __useGetFileEventsQuery__
 *
 * To run a query within a React component, call `useGetFileEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileEventsQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileEventsQuery(baseOptions: Apollo.QueryHookOptions<GetFileEventsQuery, GetFileEventsQueryVariables> & ({ variables: GetFileEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileEventsQuery, GetFileEventsQueryVariables>(GetFileEventsDocument, options);
      }
export function useGetFileEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileEventsQuery, GetFileEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileEventsQuery, GetFileEventsQueryVariables>(GetFileEventsDocument, options);
        }
export function useGetFileEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileEventsQuery, GetFileEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileEventsQuery, GetFileEventsQueryVariables>(GetFileEventsDocument, options);
        }
export type GetFileEventsQueryHookResult = ReturnType<typeof useGetFileEventsQuery>;
export type GetFileEventsLazyQueryHookResult = ReturnType<typeof useGetFileEventsLazyQuery>;
export type GetFileEventsSuspenseQueryHookResult = ReturnType<typeof useGetFileEventsSuspenseQuery>;
export type GetFileEventsQueryResult = Apollo.QueryResult<GetFileEventsQuery, GetFileEventsQueryVariables>;
export const GetFileResourcesDocument = gql`
    query getFileResources($fileId: Long!) {
  projectFileById(fileId: $fileId) {
    organisms {
      ...OrganismTile
    }
    parents {
      id
      name
      description
      sampleCount
      parentType {
        name
      }
    }
    samples {
      ...SampleTile
    }
  }
}
    ${OrganismTileFragmentDoc}
${SampleTileFragmentDoc}`;

/**
 * __useGetFileResourcesQuery__
 *
 * To run a query within a React component, call `useGetFileResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileResourcesQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetFileResourcesQuery, GetFileResourcesQueryVariables> & ({ variables: GetFileResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileResourcesQuery, GetFileResourcesQueryVariables>(GetFileResourcesDocument, options);
      }
export function useGetFileResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileResourcesQuery, GetFileResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileResourcesQuery, GetFileResourcesQueryVariables>(GetFileResourcesDocument, options);
        }
export function useGetFileResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileResourcesQuery, GetFileResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileResourcesQuery, GetFileResourcesQueryVariables>(GetFileResourcesDocument, options);
        }
export type GetFileResourcesQueryHookResult = ReturnType<typeof useGetFileResourcesQuery>;
export type GetFileResourcesLazyQueryHookResult = ReturnType<typeof useGetFileResourcesLazyQuery>;
export type GetFileResourcesSuspenseQueryHookResult = ReturnType<typeof useGetFileResourcesSuspenseQuery>;
export type GetFileResourcesQueryResult = Apollo.QueryResult<GetFileResourcesQuery, GetFileResourcesQueryVariables>;
export const GetFilesTileInfoDocument = gql`
    query getFilesTileInfo($fileIds: [Long!]) {
  projectFilesById(fileIds: $fileIds) {
    ...ProjectFileTile
  }
}
    ${ProjectFileTileFragmentDoc}`;

/**
 * __useGetFilesTileInfoQuery__
 *
 * To run a query within a React component, call `useGetFilesTileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesTileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesTileInfoQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useGetFilesTileInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesTileInfoQuery, GetFilesTileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesTileInfoQuery, GetFilesTileInfoQueryVariables>(GetFilesTileInfoDocument, options);
      }
export function useGetFilesTileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesTileInfoQuery, GetFilesTileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesTileInfoQuery, GetFilesTileInfoQueryVariables>(GetFilesTileInfoDocument, options);
        }
export function useGetFilesTileInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilesTileInfoQuery, GetFilesTileInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilesTileInfoQuery, GetFilesTileInfoQueryVariables>(GetFilesTileInfoDocument, options);
        }
export type GetFilesTileInfoQueryHookResult = ReturnType<typeof useGetFilesTileInfoQuery>;
export type GetFilesTileInfoLazyQueryHookResult = ReturnType<typeof useGetFilesTileInfoLazyQuery>;
export type GetFilesTileInfoSuspenseQueryHookResult = ReturnType<typeof useGetFilesTileInfoSuspenseQuery>;
export type GetFilesTileInfoQueryResult = Apollo.QueryResult<GetFilesTileInfoQuery, GetFilesTileInfoQueryVariables>;
export const ValidateFileNamesDocument = gql`
    query validateFileNames($folderId: Long!, $fileNames: [String!]) {
  fileNameExistsInCollector(folderId: $folderId, fileNames: $fileNames)
}
    `;

/**
 * __useValidateFileNamesQuery__
 *
 * To run a query within a React component, call `useValidateFileNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateFileNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateFileNamesQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      fileNames: // value for 'fileNames'
 *   },
 * });
 */
export function useValidateFileNamesQuery(baseOptions: Apollo.QueryHookOptions<ValidateFileNamesQuery, ValidateFileNamesQueryVariables> & ({ variables: ValidateFileNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateFileNamesQuery, ValidateFileNamesQueryVariables>(ValidateFileNamesDocument, options);
      }
export function useValidateFileNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateFileNamesQuery, ValidateFileNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateFileNamesQuery, ValidateFileNamesQueryVariables>(ValidateFileNamesDocument, options);
        }
export function useValidateFileNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateFileNamesQuery, ValidateFileNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateFileNamesQuery, ValidateFileNamesQueryVariables>(ValidateFileNamesDocument, options);
        }
export type ValidateFileNamesQueryHookResult = ReturnType<typeof useValidateFileNamesQuery>;
export type ValidateFileNamesLazyQueryHookResult = ReturnType<typeof useValidateFileNamesLazyQuery>;
export type ValidateFileNamesSuspenseQueryHookResult = ReturnType<typeof useValidateFileNamesSuspenseQuery>;
export type ValidateFileNamesQueryResult = Apollo.QueryResult<ValidateFileNamesQuery, ValidateFileNamesQueryVariables>;
export const PreviewDialogBasicsDocument = gql`
    query previewDialogBasics($fileId: Long!) {
  projectFileById(fileId: $fileId) {
    id
    fileName
    lastModified
    fileBrowseType
  }
}
    `;

/**
 * __usePreviewDialogBasicsQuery__
 *
 * To run a query within a React component, call `usePreviewDialogBasicsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDialogBasicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDialogBasicsQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function usePreviewDialogBasicsQuery(baseOptions: Apollo.QueryHookOptions<PreviewDialogBasicsQuery, PreviewDialogBasicsQueryVariables> & ({ variables: PreviewDialogBasicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewDialogBasicsQuery, PreviewDialogBasicsQueryVariables>(PreviewDialogBasicsDocument, options);
      }
export function usePreviewDialogBasicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewDialogBasicsQuery, PreviewDialogBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewDialogBasicsQuery, PreviewDialogBasicsQueryVariables>(PreviewDialogBasicsDocument, options);
        }
export function usePreviewDialogBasicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewDialogBasicsQuery, PreviewDialogBasicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewDialogBasicsQuery, PreviewDialogBasicsQueryVariables>(PreviewDialogBasicsDocument, options);
        }
export type PreviewDialogBasicsQueryHookResult = ReturnType<typeof usePreviewDialogBasicsQuery>;
export type PreviewDialogBasicsLazyQueryHookResult = ReturnType<typeof usePreviewDialogBasicsLazyQuery>;
export type PreviewDialogBasicsSuspenseQueryHookResult = ReturnType<typeof usePreviewDialogBasicsSuspenseQuery>;
export type PreviewDialogBasicsQueryResult = Apollo.QueryResult<PreviewDialogBasicsQuery, PreviewDialogBasicsQueryVariables>;
export const FileDownloadDocument = gql`
    query fileDownload($fileId: Long!) {
  projectFileById(fileId: $fileId) {
    id
    fileName
    fileBrowseType
  }
}
    `;

/**
 * __useFileDownloadQuery__
 *
 * To run a query within a React component, call `useFileDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileDownloadQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useFileDownloadQuery(baseOptions: Apollo.QueryHookOptions<FileDownloadQuery, FileDownloadQueryVariables> & ({ variables: FileDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileDownloadQuery, FileDownloadQueryVariables>(FileDownloadDocument, options);
      }
export function useFileDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileDownloadQuery, FileDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileDownloadQuery, FileDownloadQueryVariables>(FileDownloadDocument, options);
        }
export function useFileDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FileDownloadQuery, FileDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileDownloadQuery, FileDownloadQueryVariables>(FileDownloadDocument, options);
        }
export type FileDownloadQueryHookResult = ReturnType<typeof useFileDownloadQuery>;
export type FileDownloadLazyQueryHookResult = ReturnType<typeof useFileDownloadLazyQuery>;
export type FileDownloadSuspenseQueryHookResult = ReturnType<typeof useFileDownloadSuspenseQuery>;
export type FileDownloadQueryResult = Apollo.QueryResult<FileDownloadQuery, FileDownloadQueryVariables>;
export const GetFileSuggestionsContextDocument = gql`
    query getFileSuggestionsContext($fileIds: [Long!]!) {
  projectFilesById(fileIds: $fileIds) {
    organisms {
      id
      name
    }
    parents {
      id
      name
      parentType {
        name
      }
    }
    samples {
      id
      name
      type {
        id
        name
      }
    }
    playbookEvents {
      id
      alias
      created
      playbook {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetFileSuggestionsContextQuery__
 *
 * To run a query within a React component, call `useGetFileSuggestionsContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileSuggestionsContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileSuggestionsContextQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useGetFileSuggestionsContextQuery(baseOptions: Apollo.QueryHookOptions<GetFileSuggestionsContextQuery, GetFileSuggestionsContextQueryVariables> & ({ variables: GetFileSuggestionsContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileSuggestionsContextQuery, GetFileSuggestionsContextQueryVariables>(GetFileSuggestionsContextDocument, options);
      }
export function useGetFileSuggestionsContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileSuggestionsContextQuery, GetFileSuggestionsContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileSuggestionsContextQuery, GetFileSuggestionsContextQueryVariables>(GetFileSuggestionsContextDocument, options);
        }
export function useGetFileSuggestionsContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileSuggestionsContextQuery, GetFileSuggestionsContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileSuggestionsContextQuery, GetFileSuggestionsContextQueryVariables>(GetFileSuggestionsContextDocument, options);
        }
export type GetFileSuggestionsContextQueryHookResult = ReturnType<typeof useGetFileSuggestionsContextQuery>;
export type GetFileSuggestionsContextLazyQueryHookResult = ReturnType<typeof useGetFileSuggestionsContextLazyQuery>;
export type GetFileSuggestionsContextSuspenseQueryHookResult = ReturnType<typeof useGetFileSuggestionsContextSuspenseQuery>;
export type GetFileSuggestionsContextQueryResult = Apollo.QueryResult<GetFileSuggestionsContextQuery, GetFileSuggestionsContextQueryVariables>;
export const SearchProjectFilesDocument = gql`
    query searchProjectFiles($searchTerm: String, $fileExtensions: [String], $projectId: Long, $genomeIds: [Long!], $eventIds: [Long!], $parentIds: [Long!], $sampleIds: [Long!], $sortOrder: String, $folderId: Long) {
  search {
    projectFilesContextSearch(
      searchTerm: $searchTerm
      fileExtensions: $fileExtensions
      projectId: $projectId
      genomeIds: $genomeIds
      eventIds: $eventIds
      parentIds: $parentIds
      sampleIds: $sampleIds
      sortOrder: $sortOrder
      folderId: $folderId
    ) {
      totalCount
      projectFiles {
        ...ProjectFileGrid
        path
        project {
          id
          name
          description
          color
        }
      }
    }
  }
}
    ${ProjectFileGridFragmentDoc}`;

/**
 * __useSearchProjectFilesQuery__
 *
 * To run a query within a React component, call `useSearchProjectFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProjectFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProjectFilesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      fileExtensions: // value for 'fileExtensions'
 *      projectId: // value for 'projectId'
 *      genomeIds: // value for 'genomeIds'
 *      eventIds: // value for 'eventIds'
 *      parentIds: // value for 'parentIds'
 *      sampleIds: // value for 'sampleIds'
 *      sortOrder: // value for 'sortOrder'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useSearchProjectFilesQuery(baseOptions?: Apollo.QueryHookOptions<SearchProjectFilesQuery, SearchProjectFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProjectFilesQuery, SearchProjectFilesQueryVariables>(SearchProjectFilesDocument, options);
      }
export function useSearchProjectFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProjectFilesQuery, SearchProjectFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProjectFilesQuery, SearchProjectFilesQueryVariables>(SearchProjectFilesDocument, options);
        }
export function useSearchProjectFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchProjectFilesQuery, SearchProjectFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchProjectFilesQuery, SearchProjectFilesQueryVariables>(SearchProjectFilesDocument, options);
        }
export type SearchProjectFilesQueryHookResult = ReturnType<typeof useSearchProjectFilesQuery>;
export type SearchProjectFilesLazyQueryHookResult = ReturnType<typeof useSearchProjectFilesLazyQuery>;
export type SearchProjectFilesSuspenseQueryHookResult = ReturnType<typeof useSearchProjectFilesSuspenseQuery>;
export type SearchProjectFilesQueryResult = Apollo.QueryResult<SearchProjectFilesQuery, SearchProjectFilesQueryVariables>;